import { render, staticRenderFns } from "./orderListAllProviders.vue?vue&type=template&id=12f24cc6&scoped=true&"
import script from "./orderListAllProviders.vue?vue&type=script&lang=babel&"
export * from "./orderListAllProviders.vue?vue&type=script&lang=babel&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f24cc6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
